import { AgentsHub } from '@/containers/agents';
import { useGo } from '@/lib/useGo';

export default function AgentsRoute() {
  const go = useGo();
  return <AgentsHub go={go} />;
}
